/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Categories_CountInputs */

const en_admin_categories_count = /** @type {(inputs: Admin_Categories_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} categories`)
};

const zh_admin_categories_count = /** @type {(inputs: Admin_Categories_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`共 ${i?.count} 个分类`)
};

/**
* | output |
* | --- |
* | "{count} categories" |
*
* @param {Admin_Categories_CountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_count = /** @type {((inputs: Admin_Categories_CountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_CountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_count(inputs)
	return zh_admin_categories_count(inputs)
});
export { admin_categories_count as "admin.categories.count" }